import { buildRoasCovenantTableModel } from './buildRoasCovenantTableXml';
import {
  buildRepaymentProportionalLine,
  buildRepaymentSetoffLine,
  buildRepaymentCohortFootnote,
} from './buildRepaymentSection';
import { hasFilledRoasCurve } from './termSheetPayload';
import { previewInput } from './previewInput';

const ROAS_CURVE_FILLED_CLAUSE =
  'Minimum ROAS curve as indicatively set out in the table below between the parties, must be maintained, with a breach triggering accelerated repayment of tested cohorts.';
const ROAS_CURVE_EMPTY_CLAUSE = 'Minimum ROAS curve to be agreed';

export function buildRoasCurveClause(fields) {
  if (hasFilledRoasCurve(fields)) {
    return ROAS_CURVE_FILLED_CLAUSE;
  }
  return ROAS_CURVE_EMPTY_CLAUSE;
}

export function buildRoasTablePreview(fields) {
  const model = buildRoasCovenantTableModel(fields);
  if (!model) {
    return {
      headers: [],
      values: [],
      hasData: false,
    };
  }
  return {
    headers: model.headers,
    values: model.values,
    hasData: true,
  };
}

export function buildRepaymentSummary(fields) {
  const table = buildRoasTablePreview(fields);

  const parts = [
    `• ${buildRepaymentProportionalLine()}`,
    buildRoasCurveClause(fields),
    table.hasData ? `${table.headers.join(' | ')} — ${table.values.join(' | ')}` : '',
    `• ${buildRepaymentSetoffLine()}`,
    buildRepaymentCohortFootnote(fields),
  ];

  return parts.filter(Boolean).join('\n\n');
}

export function buildRepaymentPreviewSummary(fields) {
  const table = buildRoasTablePreview(fields);

  const parts = [
    `• ${buildRepaymentProportionalLine()}`,
    buildRoasCurveClause(fields),
    table.hasData
      ? `${table.headers.map((header) => previewInput(header)).join(' | ')} — ${table.values
          .map((value) => previewInput(value))
          .join(' | ')}`
      : '',
    `• ${buildRepaymentSetoffLine()}`,
    previewInput(buildRepaymentCohortFootnote(fields)),
  ];

  return parts.filter(Boolean).join('\n\n');
}
